export function isStaffMember(user) {
  return user?.role === 'Supervisor'
}

export function staffMustChangePassword(user) {
  return isStaffMember(user) && !user?.last_password_change
}

export function canStaff(user, ability, subject) {
  if (!user || !isStaffMember(user)) {
    return true
  }

  const permissions = user.staff_permissions?.[subject]
  if (!permissions) {
    return false
  }

  return Boolean(permissions[ability])
}

export function canStaffCreate(user, subject) {
  return canStaff(user, 'create', subject)
}

export function canStaffChange(user, subject) {
  return canStaff(user, 'change', subject)
}

export function canStaffViewOtherSupervisorsOrders(user) {
  return canStaff(user, 'view_others', 'orders')
}

export function canStaffChangeOtherSupervisorsOrders(user) {
  return canStaffViewOtherSupervisorsOrders(user)
    && canStaffChange(user, 'orders')
    && canStaff(user, 'change_others', 'orders')
}
